const filterItemReducer = (state = 'Tipo', action) => {
    switch(action.type)
    {
        case 'changeFilterItem':
            state = action.filter;
            return state;
        default :
            return state;
    }
}

export default filterItemReducer;